<template>
  <div>
    <apexchart
      :ref="'apexRadialBar' + refLabel"
      type="radialBar"
      :height="height"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: "RadialBar",
  props: {
    datasets: {
      type: Array,
      require: true,
    },
    labels: {
      type: [Object, Array],
      require: true,
    },
    height: {
      type: String,
      require: true,
    },
    refLabel: {
      type: String
    },
  },
  data() {
    return {
      series: [0, 0],
      options: {
        chart: {
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: "12px",
              },
              value: {
                fontSize: "22px",
                fontWeight: "bolder",
                formatter: (value) => {
                  return value;
                },
              },
              // total: {
              //   show: true,
              //   label: "Total",
              //   formatter: function (w) {
              //     return w.globals.seriesTotals.reduce((acc, curr) => {
              //       return acc + curr;
              //     }, 0);
              //   },
              // },
            },
          },
        },
        labels: [],
      },
    };
  },
  methods: {
    updateSeries() {
      this.$refs[`apexRadialBar${this.refLabel}`].updateOptions({
        labels: this.labels,
        series: this.datasets,
      });
    },
  },
  watch: {
    // labels: {
    //   handler() {
    //     console.log("labels");
    //     queueMicrotask(() => {
    //       this.updateSeries();
    //     });
    //   },
    //   deep: true,
    //   immediately: true,
    // },
    // series: {
    //   handler() {
    //     console.log("series");
    //     queueMicrotask(() => {
    //       this.updateSeries();
    //     });
    //   },
    //   deep: true,
    //   immediately: true,
    // },
    // "$refs.[apexRadialBar + refLabel]": {
    //   immediate: true,
    //   handler(value) {
    //     console.log("$refs.foo watcher", value, this.$refs.[apexRadialBar + refLabel]);
    //   },
    // },
    // datasets: {
    //   handler() {
    //     console.log("datasets", this.$refs.apexRadialBar);
    //     //setTimeout(() => {
    //     this.updateSeries();
    //     //}, 4000);
    //   },
    //   deep: true
    // },
    datasets: {
      handler: "updateSeries",
      deep: true,
      immediate: true,
    },
  },
};
</script>
